/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ErrorResponse model module.
* @module model/ErrorResponse
* @version 2020-12-7
*/
export default class ErrorResponse {
    /**
    * Constructs a new <code>ErrorResponse</code>.
    * エラーレスポンス
    * @alias module:model/ErrorResponse
    * @class
    * @param result {module:model/ErrorResponse.ResultEnum} 
    * @param status {Number} HTTPステータスコード
    * @param code {String} エラーコード
    * @param errorTitle {String} エラータイトル
    * @param errorMessage {String} エラーメッセージ
    */

    constructor(result, status, code, errorTitle, errorMessage) {
        
        
        this['result'] = result;
        this['status'] = status;
        this['code'] = code;
        this['errorTitle'] = errorTitle;
        this['errorMessage'] = errorMessage;
        
    }

    /**
    * Constructs a <code>ErrorResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ErrorResponse} obj Optional instance to populate.
    * @return {module:model/ErrorResponse} The populated <code>ErrorResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ErrorResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('errorTitle')) {
                obj['errorTitle'] = ApiClient.convertToType(data['errorTitle'], 'String');
            }
            if (data.hasOwnProperty('errorMessage')) {
                obj['errorMessage'] = ApiClient.convertToType(data['errorMessage'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ErrorResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * HTTPステータスコード
    * @member {Number} status
    */
    'status' = undefined;
    /**
    * エラーコード
    * @member {String} code
    */
    'code' = undefined;
    /**
    * エラータイトル
    * @member {String} errorTitle
    */
    'errorTitle' = undefined;
    /**
    * エラーメッセージ
    * @member {String} errorMessage
    */
    'errorMessage' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG"    };

}
